import React, { useState, useEffect } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import moment from 'moment'
import Isvg from 'react-inlinesvg'
import * as queryString from "query-string"

import toggles from 'feature-toggles'
import propertyService from "data/property"
import api_match from "data/interface/api"
import folderService from "data/folder"
import importService from "data/import"
import automationService from "data/automation"
import keyService, * as chord from "data/key"
import { local } from "data/lib/local-json"

import PropertyListTable from "components/folder/property-list/property-list-table"
import NewPropertyModal from "components/folder/property-list/new-property-modal"
import CalcButton from "components/folder/calc/calc-button"
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import { ContentSummary_s } from "styles/app-styles"
import PropertyList_s from "components/folder/property-list/property-list-styles"
import { AddIcon } from "images/icons/tools"

const PropertyList = (props: RouteComponentProps) => {
  const [properties, setProperties] = useState<object[]>([])
  const [currentFolder, setFolder] = useState<object>({})
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [showAddProp, setShowAddProp] = useState<boolean>(false)

  const openAddPropertyModal = () => {
    automationService.broadcast("NEW_PROPERTY_MODAL_OPENING", {})
    setShowAddProp(true)
  }

  useEffect(() => {
    const queryParams = queryString.parse(window.location.search)
    if(queryParams.new) openAddPropertyModal()

    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_PLUS && k.down === true:
          openAddPropertyModal()
          break
      }
    })

    const propertySubscription = propertyService.stream().subscribe(data => {
      const folderid = _.last(local('folderPath'))
      const inCurrentFolder = (xs) => _.filter(xs, {folderid})
      api_match(
        data,
        init  => setProperties(inCurrentFolder(init.value)),
        ok    => {
          setProperties(inCurrentFolder(ok.value))
        },
        err   => {
          setProperties(inCurrentFolder(err.value)) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const currentFolderId = _.last(local('folderPath'))
    folderService.fetchFolder(currentFolderId)
    .then(folder => {
      if(folder) {
        setFolder(folder)
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [])

  const AddProperty = () => {
    return (
      <a onClick={() => openAddPropertyModal()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <PropertyList_s>
      <Toolbar>
        <AddProperty />
        <ImportIcon />
        <ExportIcon properties={properties} template="property" />
        <CalcButton />
      </Toolbar>
      { showImport ? <Import /> :
        <div>
          <NewPropertyModal show={showAddProp} close={() => {setShowAddProp(false); automationService.broadcast("NEW_PROPERTY_MODAL_CLOSING", {})}}/>
          <PropertyListTable data={properties} />
          { !showImport && <ContentSummary_s>
            <a href="/n/folder/settings">Folder Settings</a>: Report Begin: {currentFolder && currentFolder['reportbegindate'] ? moment(currentFolder['reportbegindate']).format('MM/DD/YYYY') : 'N/A'} | Term: {currentFolder && currentFolder['term'] ? currentFolder['term'] : 'N/A'}
          </ContentSummary_s> }
        </div>
      }
    </PropertyList_s>
  )
}

export default PropertyList
